export * from "./tabs-custom";
export { TabsCustom as default } from "./tabs-custom";
